import React from 'react';
import { CoreForumViewNode } from '../core/CoreForumViewNode';

/**
 * WorkspaceViewNode - Workspace 專用的節點查看組件包裝器
 * 
 * @param {Function} props.buildGroupContext - 從頁面傳遞的 context 構建函數
 * @param {string} props.mode - 模式標識
 */
export const WorkspaceViewNode = ({ 
  open, 
  onClose, 
  nodeContent, 
  ws, 
  groupId, 
  onEditorOpen, 
  onEditorClose, 
  graphNodes, 
  graphEdges = [],
  allTagConfigs = {},
  buildGroupContext,
  mode = 'workspace',
  onRefresh,
  onNodeUpdated,
  onNodeDeleted
}) => {
  return (
    <CoreForumViewNode
      open={open}
      onClose={onClose}
      nodeContent={nodeContent}
      ws={ws}
      groupId={groupId}
      onEditorOpen={onEditorOpen}
      onEditorClose={onEditorClose}
      graphNodes={graphNodes}
      graphEdges={graphEdges}
      allTagConfigs={allTagConfigs}
      buildGroupContext={buildGroupContext}
      mode={mode}
      onRefresh={onRefresh}
      onNodeUpdated={onNodeUpdated}
      onNodeDeleted={onNodeDeleted}
    />
  );
};

export default WorkspaceViewNode;
